export const CHORE_APPROVED_TYPES = {
    PAID: 'PAID',
    UNPAID: 'UNPAID',
    UNPAID_ERROR: 'UNPAID_ERROR'
} as const